/* ============================================================
   CART DRAWER
   Erahaus Shopify Theme for Scent of Qui
   ============================================================ */

(function () {
  'use strict';

  var cleanupCart = null;

  function isHeaderSectionTarget(target) {
    return target && (
      (target.matches && target.matches('.js-site-header, .js-cart-drawer')) ||
      (target.querySelector && target.querySelector('.js-site-header, .js-cart-drawer'))
    );
  }

  function destroyCart() {
    if (!cleanupCart) return;
    cleanupCart();
    cleanupCart = null;
  }

  function initCartDrawer() {
    destroyCart();

    if (document.body.classList.contains('is-exhibition-mode')) return;
    if (document.body.classList.contains('is-sales-disabled')) return;

    function updateCartCount(cart) {
      var count = document.querySelector('.site-header__cart-count');
      if (!count || !cart) return;

      count.textContent = cart.item_count;
    }

    window.__refreshCartCount = function () {
      return fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          updateCartCount(cart);
          return cart;
        });
    };

    var toggle  = document.querySelector('.js-cart-toggle');
    var drawer  = document.querySelector('.js-cart-drawer');
    var overlay = document.querySelector('.js-cart-overlay');
    var close   = document.querySelector('.js-cart-close');
    var body    = document.querySelector('.js-cart-body');

    if (!toggle || !drawer) return;

    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    toggle.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('menu-open');

    /* ── Open / Close ─────────────────────────────────────────── */

    function openCart() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.classList.add('menu-open');
      if (window.__lenis) window.__lenis.stop();
      loadCart();
      if (close) close.focus();
    }

    function closeCart() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('menu-open');
      if (window.__lenis) window.__lenis.start();
      toggle.focus();
    }

    var onToggleClick = function (e) {
      e.preventDefault();
      openCart();
    };
    var onCloseClick = closeCart;
    var onOverlayClick = closeCart;
    var onKeydown = function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeCart();
      }
    };

    toggle.addEventListener('click', onToggleClick);

    if (close)   close.addEventListener('click', onCloseClick);
    if (overlay) overlay.addEventListener('click', onOverlayClick);

    document.addEventListener('keydown', onKeydown);

    cleanupCart = function () {
      toggle.removeEventListener('click', onToggleClick);
      if (close) close.removeEventListener('click', onCloseClick);
      if (overlay) overlay.removeEventListener('click', onOverlayClick);
      document.removeEventListener('keydown', onKeydown);

      if (drawer.classList.contains('is-open')) {
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('menu-open');
        if (window.__lenis) window.__lenis.start();
      }

      window.__refreshCartCount = null;
    };

    /* ── Cart Fetch + Render ──────────────────────────────────── */

    function formatMoney(cents, currency) {
      var amount = Math.round(cents / 100);
      return amount.toLocaleString() + ' ' + (currency || 'AED');
    }

    function renderEmpty() {
      if (!body) return;
      body.innerHTML =
        '<p class="cart-drawer__empty">Your cart is empty.</p>' +
        '<a class="cart-drawer__continue" href="/collections">Continue shopping</a>';
    }

    function renderCart(cart) {
      if (!body) return;

      if (!cart.item_count) {
        renderEmpty();
        return;
      }

      var itemsHtml = cart.items.map(function (item) {
        return (
          '<div class="cart-drawer__item">' +
            '<div class="cart-drawer__item-info">' +
              '<p class="cart-drawer__item-title">' + escapeHtml(item.product_title) + '</p>' +
              '<p class="cart-drawer__item-qty">Qty ' + item.quantity + '</p>' +
            '</div>' +
            '<p class="cart-drawer__item-price">' + formatMoney(item.final_line_price, cart.currency) + '</p>' +
          '</div>'
        );
      }).join('');

      var subtotalHtml =
        '<div class="cart-drawer__subtotal">' +
          '<span>Subtotal</span>' +
          '<span>' + formatMoney(cart.items_subtotal_price, cart.currency) + '</span>' +
        '</div>';

      var actionsHtml =
        '<div class="cart-drawer__actions">' +
          '<a class="cart-drawer__view-cart" href="/cart">View Cart</a>' +
        '</div>';

      body.innerHTML = itemsHtml + subtotalHtml + actionsHtml;
    }

    function loadCart() {
      if (!body) return;
      body.innerHTML = '<p class="cart-drawer__loading">Loading…</p>';

      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          updateCartCount(cart);
          renderCart(cart);
        })
        .catch(renderEmpty);
    }

    /* ── Helpers ─────────────────────────────────────────────── */

    function escapeHtml(str) {
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }
  }

  document.addEventListener('shopify:section:unload', function (e) {
    if (isHeaderSectionTarget(e.target)) destroyCart();
  });

  document.addEventListener('shopify:section:load', function (e) {
    if (isHeaderSectionTarget(e.target)) initCartDrawer();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartDrawer);
  } else {
    initCartDrawer();
  }

})();
